<header *ngIf="showHeader">
	<div class="wrapper">
		<!-- This small hack is needed for a proper headline aligning in ie11 -->
		<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
		<div *ngIf="isIE" style="height: 48px"></div>
		<ng-container *ngIf="!title">
			<ng-content select="h5"></ng-content>
		</ng-container>
		<ng-content select="[switchFilter]"></ng-content>
		<ng-content select="header"></ng-content>
		<stages-toolbar [toolbarId]="toolbarId" [items]="toolbarItems" />
		<ng-container *ngIf="showZoomToolbar && expanded">
			<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
			<div style="flex-grow: 1"></div>
			<stages-zoom-toolbar />
		</ng-container>
		<stages-button-expand-collapse
			*ngIf="contentCollapsible && showCollapseOption"
			class="action"
			[classes]="'menu-button'"
			[isCollapsed]="!expanded"
			(pressedButton)="toggleContentView()"
		/>
		<stages-menu
			class="action"
			[menuId]="menuId"
			iconClasses="ico ico-more-vertical"
			openTo="bottom"
			[items]="menuItems"
			[noCollapse]="menuNoCollapse"
			(click)="forceShowContent()"
		/>
	</div>
</header>

<ng-content></ng-content>
